import request from '@/utils/request'

const userApi = {
  // Login: '',
  Login: '/api/piao/sys/getLoginPaw',
  Logout: '/auth/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/auth/register',
  twoStepCode: '/auth/2step-code',
  SendSms: '/account/sms',
  SendSmsErr: '/account/sms_err',
  // get my info
  UserInfo: '/user/info',
  UserMenu: '/user/nav',
}

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  return request({
    url: userApi.Login,
    method: 'post',
    data: parameter,
  })
}
export function getPopulation(parameter) {
  return request({
    url: '/api/piao/statistics/getPopulation',
    method: 'get',
    data: parameter,
  })
}

export function getInvoiceTrend(parameter) {
  return request({
    url: '/api/piao/statistics/getInvoiceTrend',
    method: 'get',
    data: parameter,
  })
}

export function getInvoiceStatus(parameter) {
  return request({
    url: '/api/piao/statistics/getInvoiceStatus',
    method: 'get',
    data: parameter,
  })
}

export function getInvoiceScatter(parameter) {
  return request({
    url: '/api/piao/statistics/getInvoiceScatter',
    method: 'get',
    data: parameter,
  })
}
export function getInvoiceAdminPageList(parameter) {
  return request({
    url: '/api/piao/invoice/getInvoiceAdminPageList',
    method: 'post',
    data: parameter,
  })
}
export function exportInvoiceData(parameter) {
  return request({
    url: '/api/piao/invoice/exportInvoiceData',
    method: 'post',
    data: parameter,
    responseType: 'blob'
  })
}

export function getSourceOrderListByInvoicePageList(parameter) {
  return request({
    url: '/api/piao/invoice/getVehicleRecordListByInvoiceId',
    method: 'post',
    data: parameter,
  })
}
export function getInvoiceDetailsAdmin(parameter) {
  return request({
    url: '/api/piao/invoice/getInvoiceDetailsAdmin',
    method: 'get',
    params: parameter,
  })
}

export function getUserPageList(parameter) {
  return request({
    url: '/api/piao/user/getUserPageList',
    method: 'post',
    data: parameter,
  })
}
// 超
export function getSysUserPageList(parameter) {
  return request({
    url: '/api/piao/sys/getSysUserPageList',
    method: 'post',
    data: parameter,
  })
}

export function getVehicleRecordListAdmin(parameter) {
  return request({
    url: '/api/piao/vehicle/record/getVehicleRecordListAdmin',
    method: 'post',
    data: parameter,
  })
}

export function exportOrderData(parameter) {
  return request({
    url: 'api/piao/vehicle/record/exportOrderData',
    method: 'post',
    data: parameter,
    responseType: 'blob'
  })
}

export function getNumberPlatePageList(parameter) {
  return request({
    url: '/api/piao/plate/getNumberPlatePageList',
    method: 'post',
    data: parameter,
  })
}

export function saveNumberPlateStatus(parameter) {
  return request({
    url: '/api/piao/plate/saveNumberPlateStatus',
    method: 'post',
    data: parameter,
  })
}

export function getVehicleParkadePageList(parameter) {
  return request({
    url: '/api/piao/vehicle/parkade/getVehicleParkadePageList',
    method: 'post',
    data: parameter,
  })
}

export function saveInvoiceStatus(parameter) {
  return request({
    url: '/api/piao/invoice/saveInvoiceStatus',
    method: 'post',
    data: parameter,
  })
}
export function applyHong(parameter) {
  return request({
    url: '/api/piao/invoice/applyHong',
    method: 'post',
    data: parameter,
  })
}

// id examineStatus
export function examineInvoice(parameter) {
  return request({
    url: '/api/piao/invoice/examineInvoice',
    method: 'post',
    data: parameter,
  })
}

export function saveHongInvoiceStatus(parameter) {
  return request({
    url: '/api/piao/invoice/saveHongInvoiceStatus',
    method: 'post',
    data: parameter,
  })
}

export function delVehicleRecord(parameter) {
  return request({
    url: '/api/piao/vehicle/record/delVehicleRecord',
    method: 'get',
    params: parameter,
  })
}

export function addNumberPlateAdmin(parameter) {
  return request({
    url: '/api/piao/plate/addNumberPlateAdmin',
    method: 'post',
    data: parameter,
  })
}

export function unbindNumberPlateAdmin(parameter) {
  return request({
    url: '/api/piao/plate/unbindNumberPlateAdmin',
    method: 'post',
    data: parameter,
  })
}

export function saveVehicleParkade(parameter) {
  return request({
    url: '/api/piao/vehicle/parkade/saveVehicleParkade',
    method: 'post',
    data: parameter,
  })
}
export function addVehicleParkade(parameter) {
  return request({
    url: '/api/piao/vehicle/parkade/addVehicleParkade',
    method: 'post',
    data: parameter,
  })
}
export function downQrCodeByParkadeId(parameter) {
  return request({
    url: `/api/piao/vehicle/parkade/downQrCodeByParkadeId?parkadeId=${parameter.id}`,
    method: 'get'
  })
}

export function addSysUser(parameter) {
  return request({
    url: '/api/piao/sys/addSysUser',
    method: 'post',
    data: parameter,
  })
}

export function saveSysUser(parameter) {
  return request({
    url: '/api/piao/sys/saveSysUser',
    method: 'post',
    data: parameter,
  })
}

export function saveSysUserStatus(parameter) {
  return request({
    url: '/api/piao/sys/saveSysUserStatus',
    method: 'post',
    data: parameter,
  })
}

export function searchEnterprise(parameter) {
  return request({
    url: '/api/piao/invoice/searchEnterprise',
    method: 'get',
    params: parameter,
  })
}

export function getPayTaxes(parameter) {
  return request({
    url: '/api/piao/invoice/getPayTaxes',
    method: 'get',
    params: parameter,
  })
}

export function getMerchantAll(parameter) {
  return request({
    url: '/api/piao/sys/getMerchantAll',
    method: 'post',
    data: parameter,
  })
}

//
export function saveSysEnterprise(parameter) {
  return request({
    url: '/api/piao/enterprise/saveSysEnterprise',
    method: 'post',
    data: parameter,
  })
}

export function getEnterprisePageList(parameter) {
  return request({
    url: '/api/piao/enterprise/getEnterprisePageList',
    method: 'post',
    data: parameter,
  })
}
export function addSysEnterprise(parameter) {
  return request({
    url: '/api/piao/enterprise/addSysEnterprise',
    method: 'post',
    data: parameter,
  })
}
export function delSysEnterprise(parameter) {
  return request({
    url: '/api/piao/enterprise/delSysEnterprise',
    method: 'post',
    data: parameter,
  })
}
export function getSysEnterpriseList(parameter) {
  return request({
    url: '/api/piao/enterprise/getSysEnterpriseList',
    method: 'post',
    data: parameter,
  })
}

export function getJumpActivation(parameter) {
  return request({
    url: '/api/piao/enterprise/getJumpActivation',
    method: 'get',
    params: parameter,
  })
}
// =======÷

export function getSmsCaptcha(parameter) {
  return request({
    url: userApi.SendSms,
    method: 'post',
    data: parameter,
  })
}

export function getInfo() {
  return request({
    url: userApi.UserInfo,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  })
}

export function getCurrentUserNav() {
  return request({
    url: userApi.UserMenu,
    method: 'get',
  })
}

export function logout() {
  return new Promise((resolve, reject) => {
    resolve()
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step(parameter) {
  return request({
    url: userApi.twoStepCode,
    method: 'post',
    data: parameter,
  })
}
